import { SESSION_TIME } from '../../../config';

import * as ActionTypes from './constants';

export const setUserCreated = () => {
  return (dispatch, getState) => {
    const userCreatedAt = getState().user.createdAt;

    if (!userCreatedAt) {
      dispatch({
        type: ActionTypes.SET_USER_CREATED,
        payload: { timestamp: Date.now() },
      });
    }
  };
};

export const setUserState = () => {
  return (dispatch, getState) => {
    const userCreatedAt = getState().user.createdAt;
    let isReturningUser = false;

    if (userCreatedAt) {
      const currentTimeStamp = Date.now();

      if (userCreatedAt + SESSION_TIME < currentTimeStamp) {
        isReturningUser = true;
      }
    }

    dispatch({
      type: ActionTypes.SET_USER_STATE,
      payload: {
        isReturningUser,
      },
    });
  };
};
